export default __webpack_public_path__ + "static/media/wallet-connect.d1c9d6ff.svg";